/**
 * EvaluationForm 编辑模块 - 常量配置
 */

import type { RatingType } from "./types";

// ==================== Tab 配置 ====================

export const TAB_ITEMS_CONFIG = [
  {
    key: "admission-assessment",
    label: "供应商准入评估",
  },
  // {
  //   key: "assessment-invite",
  //   label: "评估邀请",
  // },
] as const;

// ==================== 评估阶段配置 ====================

export const EVALUATION_CATEGORIES = [
  { label: "前置筛选评估", value: "pre_screening" },
  { label: "质量维度", value: "quality" },
  { label: "体系维度", value: "system" },
  { label: "技术能力维度", value: "technical" },
  { label: "成本竞争力维度", value: "cost" },
  { label: "交付能力维度", value: "delivery" },
  { label: "创新能力维度", value: "innovation" },
] as const;

// ==================== 评估人选项 ====================

export const ASSESSOR_OPTIONS = [
  { label: "陈怡然", value: "chenYiran" },
  { label: "张三", value: "zhangSan" },
  { label: "李四", value: "liSi" },
  { label: "王五", value: "wangWu" },
] as const;

// ==================== 评级类型配置 ====================

export const RATING_TYPE_CONFIG: Record<RatingType, { label: string }> = {
  excellent: { label: "优评" },
  middle: { label: "中评" },
  poor: { label: "差评" },
  na: { label: "NA" },
};

// ==================== 评估结果数据 ====================

export const ASSESSMENT_RESULTS = [
  {
    name: "前置筛选评估结果",
    score: 2,
    color: "#FD7E14",
    evaluators: ["王小胡"],
  },
  {
    name: "基本准入评估结果",
    score: 2,
    color: "#FD7E14",
    evaluators: ["吴剑", "李华"],
  },
  {
    name: "正式准入评估结果",
    score: 1,
    color: "#C9184A",
    evaluators: ["姜维", "邵彤柯", "韦秋和"],
  },
] as const;

// ==================== 模拟数据 ====================

export const MOCK_ASSESSMENT_INVITE_DATA = [
  // 已评估的行
  {
    evaluationTemplateIds: ["pre_screening"],
    evaluationTemplateNames: ["前置筛选评估"],
    purchaseUserId: "chenYiran",
    purchaseUserName: "陈怡然",
    evaluationStatus: 5,
  },
  // 未评估的行
  {
    evaluationTemplateIds: ["system"],
    evaluationTemplateNames: ["体系维度"],
    purchaseUserId: "liSi",
    purchaseUserName: "李四",
    evaluationStatus: 1,
  },
];

// ==================== 评估者信息 ====================

export const REVIEWER_LIST = [
  { label: "昆彦橦", key: "reviewer1" },
  { label: "周江", key: "reviewer2" },
  { label: "孙子渔", key: "reviewer3" },
  { label: "孙栩", key: "reviewer4" },
  { label: "李青", key: "reviewer5" },
  { label: "冯雪梅", key: "reviewer6" },
] as const;

// ==================== 样式常量 ====================

/**
 * 评估状态样式
 */
export const ASSESSMENT_STATUS_STYLE = {
  ASSESSED: {
    backgroundColor: "#D9FFDB",
    color: "#333333",
    dotColor: "#00B42A",
  },
  NOT_ASSESSED: {
    backgroundColor: "#FFF3D9",
    color: "#333333",
    dotColor: "#F96800",
  },
} as const;

export const STATUS_DOT_SIZE = {
  width: "6px",
  height: "6px",
};

// ==================== Modal 配置 ====================

export const MODAL_CONFIG = {
  width: "1000px",
  height: "80vh",
  bodyHeight: "calc(80vh - 110px)",
} as const;

// ==================== 导航按钮配置 ====================

export const NAVIGATION_BUTTON_CONFIG = {
  width: "44px",
  height: "44px",
  borderRadius: "50%",
  border: "1px solid #d9d9d9",
  backgroundColor: "#fafafa",
} as const;
